import React from 'react';
import '../styles/Distance.css';
import { Location04Icon } from 'hugeicons-react';
import { colour } from '../styles/GlobalStyles';

function Distance(props) {
    const value = props.value;
    const distanceHover = props.distanceHover;
    const showMap = props.showMap;
    const hoverTimeout = props.hoverTimeout;
    const setHoverTimeout = props.setHoverTimeout;
    const darkMode = props.darkMode;

     const handleMouseEnter = () => {
        const timeout = setTimeout(() => {
            distanceHover();
        }, 500);
        setHoverTimeout(timeout);
    };

    const handleMouseLeave = () => {
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            setHoverTimeout(null);
        }
    };

    return (
        <div 
            className={"distance-container " + (darkMode === true ? "bg-colour-white-transparent " : "bg-colour-white ") + (distanceHover !== null ? "cursor-pointer " : "") + (hoverTimeout !== null ? "distance-container-show-map " : "")}
            onMouseEnter={() => distanceHover === null || showMap === true ? null : handleMouseEnter()}
            onMouseLeave={() => distanceHover === null || showMap === true ? null : handleMouseLeave()}
        >
            <Location04Icon
                size={16}
                color={colour.gray06}
            />
            <span className="body-bold colour-primary">
                {value}
            </span>
        </div>
    )
};

export default Distance;